<!-- Inline stars (table cell display) -->
<div class="star-rating-inline" [class.star-rating-readonly]="readonly" (click)="openModal()">
  @for (star of starsArray; track star) {
    <span
      class="star-icon"
      [class.star-filled]="star <= value"
      [class.star-empty]="star > value"
    >★</span>
  }
</div>

<!-- PrimeNG dialog for review -->
<app-star-rating-modal
  [(visible)]="showModal"
  [initialValue]="value"
  [initialComment]="comment"
  (confirmed)="onConfirmed($event)"
></app-star-rating-modal>

